"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CropContainer = exports.CroppedImg = exports.Img = exports.IMAGE_CONTAINER = exports.IMAGE = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _themeContants = require("../../constants/themeContants");

var _theming = require("../../theming");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Image = function Image(_ref) {
  var src = _ref.src,
      className = _ref.className,
      round = _ref.round,
      variant = _ref.variant,
      aspectRatio = _ref.aspectRatio,
      stretch = _ref.stretch,
      width = _ref.width,
      srcset = _ref.srcset,
      otherProps = _objectWithoutProperties(_ref, ["src", "className", "round", "variant", "aspectRatio", "stretch", "width", "srcset"]);

  if (aspectRatio) {
    var antecedent = parseInt(aspectRatio.split(":")[0], 10);
    var consequent = parseInt(aspectRatio.split(":")[1], 10);
    var ratio = consequent / antecedent;
    return _react["default"].createElement(CropContainer, _extends({
      className: className,
      ratio: ratio,
      variant: variant,
      round: round,
      width: width
    }, otherProps), _react["default"].createElement(CroppedImg, {
      srcSet: srcset,
      src: src,
      stretch: stretch,
      variant: variant
    }));
  }

  return _react["default"].createElement(Img, _extends({
    src: src,
    className: className,
    round: round,
    variant: variant
  }, otherProps));
};

Image.themeProps = {
  image: {
    name: "IMAGE",
    description: "image style",
    type: _themeContants.themePropTypes.style
  },
  container: {
    name: "IMAGE_CONTAINER",
    description: "image container style",
    type: _themeContants.themePropTypes.style
  }
};
var IMAGE = "IMAGE";
exports.IMAGE = IMAGE;
var IMAGE_CONTAINER = "IMAGE_CONTAINER";
exports.IMAGE_CONTAINER = IMAGE_CONTAINER;

var Img = _styledComponents["default"].img.withConfig({
  displayName: "Image__Img",
  componentId: "sc-8949g4-0"
})(["", ";", ";"], function (p) {
  return p.round && "border-radius: 50%";
}, (0, _theming.applyVariants)(Image.themeProps.image));

exports.Img = Img;
var CroppedImg = (0, _styledComponents["default"])(Img).withConfig({
  displayName: "Image__CroppedImg",
  componentId: "sc-8949g4-1"
})(["position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);max-width:none;min-height:100%;min-width:100%;"]);
exports.CroppedImg = CroppedImg;

var CropContainer = _styledComponents["default"].div.withConfig({
  displayName: "Image__CropContainer",
  componentId: "sc-8949g4-2"
})(["position:relative;display:block;overflow:hidden;padding-bottom:", "%;min-width:100px;", ";", ";", ";"], function (p) {
  return p.ratio * 100;
}, function (p) {
  return p.width && "width: " + p.width + "px";
}, function (p) {
  return p.round && "border-radius: 50%";
}, (0, _theming.applyVariants)(Image.themeProps.container));

exports.CropContainer = CropContainer;
Image.defaultProps = {
  className: "",
  size: "medium",
  round: false,
  aspectRatio: ""
};
Image.propTypes = {
  children: _themeContants.commonPropTypes.children,
  className: _propTypes["default"].string,
  size: _themeContants.commonPropTypes.spacing,
  round: _propTypes["default"].bool,
  aspectRatio: _propTypes["default"].string
};
var _default = Image;
exports["default"] = _default;